<template>
  <div class="appBox">
    <commen-head></commen-head>
    <router-view />
    <commen-foot></commen-foot>
  </div>
</template>
<script>
import commenFoot from "@/components/Foot";
import commenHead from "@/components/Head";

export default {
  components: {
    commenFoot,
    commenHead
  }
};
</script>
<style lang="scss">
.appBox {
  position: absolute;
  min-width: 1200px;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  margin: 0;
  left: 0;
  right: 0;
}
</style>
